<div class="container col-12 pt-4" style="display: flex; justify-content: center;">
       <div class="col-sm-4"></div>
       <div class="col-sm-4" style="justify-content: center;border: 3px solid green; border-radius: 5px;"><h3><i>Payment successful for TIN {{userTIN}}</i></h3></div>
       <div class="col-sm-4"></div>
</div>
<div class="container col-12 pt-4" style="display: flex; justify-content: center;">
   <div class="col-sm-4"></div>
   <div class="col-sm-4">
      <div class="row">
         <div class="col-sm-6 text-left pl-0 ml-0">
            <button type="button" class="btn btn-sm backBtn" (click)="backToHome()">
               Home</button>
             
         </div>
         <div class="col-sm-6 text-right p-0">
            <button type="button" class="btn btn-sm saveContinueBtn" (click)="backToTaxAndPayment()">
               Tax & Payment</button>
         </div>
      </div>
   </div>
   <div class="col-sm-4"></div>
</div>



